module.exports = __webpack_public_path__ + "Banner_MUNICIPALITIES.jpg?7d4d3f518816e00eae9d8543b274fa1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/municipalities/Banner_MUNICIPALITIES.jpg
// module id = 234
// module chunks = 0